import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import axios from "axios";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Container from "react-bootstrap/Container";
import "./index.css";
import { isMobileNotTabletDevice } from "../../Utils";

const CDN_BASE_URL = process.env.REACT_APP_CDN+"angl-token-launch/";
const CDN_JSON_PATH = `${CDN_BASE_URL}past-events.json?t=${Date.now()}`;

const PastEventsCarousel = () => {
    const [events, setEvents] = useState([]);

    // Fetch JSON data
    useEffect(() => {
        const fetchEvents = async () => {
            try {
                const response = await axios.get(CDN_JSON_PATH);
                setEvents(response.data.events);
            } catch (error) {

            }
        };
        fetchEvents();
    }, []);

    // Slick settings
    const settings = {
        className: "slider variable-width",
        dots: false,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 5000,
        centerMode: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        variableWidth: true,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    dots: false
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    dots: false
                }
            }
        ]
    };

    return (
        <div className="past-slider-container" id="past-Events">
            <div className={isMobileNotTabletDevice() ? "past-mobile-container" : "container past-desktop-container"}>
                <h2 className="past-events-heading">Past Experiences</h2>
                {events.map((event, index) => (
                    <div key={index} className="past-events-list">
                        <h4 className="past-event-title">{event.title}</h4>
                        <Slider {...settings}>
                            {event.images.map((image, idx) => (
                                <div key={idx} style={{ width: isMobileNotTabletDevice() ? image.mobileWidth : image.width }}>
                                    <img
                                        src={`${CDN_BASE_URL}past-events-images/${image.url}`}
                                        alt={event.title}
                                        style={{ height: "200px", width: "100%", objectFit: "contain", aspectRatio: "1/1" }}
                                        className="past-event-images"
                                    />
                                </div>
                            ))}
                        </Slider>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default PastEventsCarousel;
